import Timelog from './Timelog';

export default Timelog;
